import { atom } from "jotai";
import { InvoiceType } from "../data/models/ContractTypes";

export interface InvoiceToggleState {
  invoiceType?: InvoiceType;
}

export const contractInvoiceState = atom<InvoiceToggleState>({
  invoiceType: undefined,
});
